var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 4H4V28H28V4ZM24.6893 6.51852H15.5578C15.5578 7.61177 15.9921 8.66025 16.7651 9.4333C17.5382 10.2063 18.5866 10.6406 19.6799 10.6406H21.362V12.2648C21.3635 14.5393 23.207 16.3828 25.4815 16.3843V7.31068C25.4815 6.87331 25.1269 6.51852 24.6893 6.51852ZM20.1713 11.0684H11.0399C11.0413 13.3429 12.8847 15.1864 15.1593 15.1879H16.8415V16.8172C16.8444 19.0918 18.6891 20.934 20.9636 20.934V11.8607C20.9636 11.4232 20.6089 11.0684 20.1713 11.0684ZM6.51852 15.6157H15.6501C16.0876 15.6157 16.4423 15.9704 16.4423 16.4079V25.4813C14.1698 25.477 12.3295 23.6343 12.3281 21.3619V19.7378H10.6406C8.36412 19.7378 6.51852 17.8923 6.51852 15.6157Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.fcf651c7744889f2d7e49698823abf0e.svg";
export { ForwardRef as ReactComponent };